import cx from 'classnames';
import NextLink from 'next/link';

import {Card, Icon, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {CTACardProps} from './CTACard.types';

import * as css from './CTACard.css';

export const CTACard: React.FC<CTACardProps> = ({
  className,
  fullWidth,
  title,
  content,
  href,
  onClick,
}) => {
  const hasNavigation = !!(href || onClick);

  const renderedCard = (
    <Card
      as={href ? 'a' : 'div'}
      variant="burgundy"
      className={cx(
        css.root({hasNavigation, fullWidth: !!fullWidth}),
        sprinkles({
          flex: 'flex',
          dir: 'col',
          gap: 20,
        }),
        className,
      )}
      onClick={onClick}>
      <div className={sprinkles({flex: 'flex', pos: 'relative'})}>
        <Text
          variant="heading3"
          color="ecruWhite"
          className={sprinkles({flex: 'flex', grow: 1, mR: hasNavigation ? 96 : 0})}>
          {title}
        </Text>
        {hasNavigation && (
          <div
            className={sprinkles({
              pos: 'absolute',
              top: 0,
              right: 0,
              radius: 'circle',
              bg: 'eggplant',
              size: 56,
              flex: 'flex',
              items: 'center',
              content: 'center',
              shrink: 0,
            })}>
            <Icon name="ArrowRight" color="white" />
          </div>
        )}
      </div>
      <Text color="ecruWhite" className={sprinkles({mR: hasNavigation ? 64 : 0})}>
        {content}
      </Text>
    </Card>
  );

  return href ? (
    <NextLink passHref href={href}>
      {renderedCard}
    </NextLink>
  ) : (
    renderedCard
  );
};
